import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {  getUserUniformGroup } from "../../services/PermissionGroup";
import { useParams, useNavigate } from "react-router-dom";
// import { NavigationBar } from "../components/MasterLayout/NavigationBar";
// import { Profile } from "../components/Profile/Profile";

export const Authen = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const hostname: string = window.location.pathname;
  const { role }: any = useParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    const checkPermissions = async () => {
      // ถ้าไม่มี role หรือ role ไม่ใช่ uniform ให้ redirect ไปหน้า 404
      if (!role || role !== "uniform") {
        navigate("/404", { replace: true });
        return;
      }

      const authenTimeoutMs = Number(process.env.REACT_APP_AUTHEN_PAGE_TIMEOUT_MS || 12000);
      const timeoutId = setTimeout(() => {
        setIsAdmin(false);
        setSuccess(true);
        setLoading(false);
      }, authenTimeoutMs);

      try {
        setLoading(true);
        
        const resp = await getUserUniformGroup();
        
        setIsAdmin(resp);
        setSuccess(true);
        setLoading(false);
        clearTimeout(timeoutId);
        
        // อัปเดต sessionStorage และปล่อย event
        if (typeof window !== "undefined" && window.sessionStorage) {
          window.sessionStorage.setItem("isUniformAdmin", resp ? "1" : "0");
        }
        
        // ปล่อย event เพื่อแจ้ง App component
        const event = new CustomEvent("uniform-admin-updated", {
          detail: { isAdmin: resp },
        });
        window.dispatchEvent(event);
        
        if (resp) {
          navigate("/backoffice/uniform-dashboard", { replace: true });
        }
      } catch (error) {
        setIsAdmin(false);
        setSuccess(true);
        setLoading(false);
        
        // อัปเดต sessionStorage เมื่อเกิด error
        if (typeof window !== "undefined" && window.sessionStorage) {
          window.sessionStorage.setItem("isUniformAdmin", "0");
        }
        
        // ปล่อย event เมื่อเกิด error
        const event = new CustomEvent("uniform-admin-updated", {
          detail: { isAdmin: false },
        });
        window.dispatchEvent(event);
      } finally {
        // Clear timeout if still pending
        try {
          clearTimeout(timeoutId);
        } catch {
          // Ignore error
        }
      }
    };

    checkPermissions();
  }, [role, navigate]);
  return (
    <>
      {loading ? (
        // แสดง loading spinner ขณะกำลังตรวจสอบสิทธิ์
        <div className="loaderpage">
          <div className="loader-box">
            <div className="spinner"></div>
          </div>
        </div>
      ) : success && !isAdmin ? (
        // แสดงหน้า permission denied เมื่อไม่มีสิทธิ์
        <Container>
          <Row>
            <Col>
              <div className="page-denied text-center align-middle">
                <img src="../../../images/locked.png" alt="" />
                <h5 className="mt-3">Permission denied.</h5>
                <p>You are not authorized to perform this page.</p>
              </div>
            </Col>
          </Row>
        </Container>
      ) : (
        // กรณีมีสิทธิ์ แต่ยังไม่ redirect (ไม่ควรเกิดขึ้น)
        <div className="loaderpage">
          <div className="loader-box">
            <div className="spinner"></div>
          </div>
        </div>
      )}
    </>
  );
};
